import { useState, useCallback, useEffect } from 'react';

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
/**
 * Emits an event from the zendesk-support-button for listeners for messenger being closed
 * @param el The element we want to use to emit, defaults to the support button
 */


var emitZendeskClosedEventToHelpButton = function emitZendeskClosedEventToHelpButton(el) {
  // Only works client side
  if (typeof window === 'undefined') {
    return;
  }

  var event = document.createEvent('Event');
  event.initEvent('zendesk-closed', true, true);

  if (el) {
    el.dispatchEvent(event);
  } else {
    var supportButton = document.getElementById('zendesk-support-button');
    supportButton && supportButton.dispatchEvent(event);
  }
};
/**
 * Emits an event from the zendesk-support-button for listeners to update the position
 * of the help button
 * @param el The element we want to use to emit, defaults to the support button
 */


var emitUpdateZendeskHelpPosition = function emitUpdateZendeskHelpPosition(el) {
  // Only works client side
  if (typeof window === 'undefined') {
    return;
  }

  var event = document.createEvent('Event');
  event.initEvent('zendesk-help-update-position', true, true);

  if (el) {
    el.dispatchEvent(event);
  } else {
    var supportButton = document.getElementById('zendesk-support-button');
    supportButton && supportButton.dispatchEvent(event);
  }
};

function zendeskSettings(isOpen) {
  var rightPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var zIndexOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var defaultWidgetOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var frames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var vertical = isOpen ? '-18px' : '-100px'; // Mobile: Make sure zendesk elements are hidden when messenger is open and vice versa.

  var zIndex = zIndexOverride || (isOpen ? '25' : '20');
  var webWidget = document.getElementById('webWidget');
  var widgetOffset = webWidget ? webWidget.getBoundingClientRect().width : defaultWidgetOffset;
  var horizontalPos = window.innerWidth - rightPos - widgetOffset;

  if (horizontalPos < 16) {
    // Make sure we always leave some left padding
    horizontalPos = 16;
  }

  window.zE('webWidget', 'updateSettings', {
    offset: {
      vertical: vertical,
      horizontal: horizontalPos
    },
    zIndex: zIndex
  });

  if (!webWidget && isOpen && frames < 10) {
    window.requestAnimationFrame(function () {
      zendeskSettings(isOpen, rightPos, zIndexOverride, defaultWidgetOffset, frames + 1);
    });
  }
}
/**
 * Hook for configuring Zendesk's chat bot app after script is rendered.
 */


function useZendeskChat(_ref) {
  var _ref$feZendeskChatbot = _ref.feZendeskChatbot,
      feZendeskChatbot = _ref$feZendeskChatbot === void 0 ? false : _ref$feZendeskChatbot;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      setIsConnected = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      setIsOnline = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      setIsLoaded = _useState6[1];

  var onClient = typeof window !== 'undefined';
  var zendeskAvailable = onClient && window.zE && feZendeskChatbot; // update state boolean for agent availablity

  var updateIsOnline = useCallback(function (status) {
    if (status === 'online') {
      setIsOnline(true);
    }
  }, [setIsOnline]);
  var configureZenDesk = useCallback(function () {
    window.zE(function () {
      setIsLoaded(true); // This adds a callback to run when agent availability changes

      window.$zopim(function () {
        window.$zopim.livechat.setOnStatus(function (status) {
          return updateIsOnline(status);
        });
        window.$zopim.livechat.setOnConnected(updateIsConnected);
        window.$zopim.livechat.button.hide();
      });
      window.zE('webWidget', 'hide');
    }); // Zendesk Styles

    window.zE('webWidget', 'updateSettings', {
      webWidget: {
        chat: {
          suppress: false
        },
        color: {
          theme: '#41434A'
        },
        // Hide on first render.
        zIndex: '-1'
      }
    });
  }, [setIsLoaded]);
  var checkForZendesk = useCallback(function () {
    if (zendeskAvailable) {
      configureZenDesk();
    } else {
      // if window.zE is not loaded,
      // wait half a second and try again
      setTimeout(checkForZendesk, 500);
    }
  }, [configureZenDesk, zendeskAvailable]); // Zendesk setup.

  useEffect(function () {
    checkForZendesk();
  }, [checkForZendesk]); // Zendesk updates.

  var onWebWidgetOpen = useCallback(function () {
    zendeskSettings(true);
  }, []);
  var onWebWidgetClose = useCallback(function () {
    zendeskSettings(false);
    emitZendeskClosedEventToHelpButton();
  }, []);
  useEffect(function () {
    if (zendeskAvailable) {
      window.zE('webWidget:on', 'open', onWebWidgetOpen);
      window.zE('webWidget:on', 'close', onWebWidgetClose);
      window.zE('webWidget', 'hide');
      zendeskSettings(false);
    }
  }, [zendeskAvailable, onWebWidgetOpen, onWebWidgetClose]);
  var updateIsConnected = useCallback(function () {
    return setIsConnected(true);
  }, [setIsConnected]);
}
/**
 * This hook is used to load the chat bot used on the NextJS platform.
 * Studio (WPP) chat bot location: web-post-purchase/src/services/Chat/Zendesk.js
 */


var ZENDESK_CHAT_ID = '';
var widgetState = {
  open: false
};
/**
 * Configuration per environment.
 * Note: Answer & chat bot is enabled on prod, not the sandbox (by app design).
 */

function setEnv(_ref) {
  var appEnv = _ref.appEnv;

  switch (appEnv) {
    case 'prod':
    case 'staging':
      ZENDESK_CHAT_ID = 'ab1969ee-6f1e-4ea7-b0fa-9c58eeeec3d3';
      break;

    default:
      ZENDESK_CHAT_ID = '1d4e0b7b-61d6-423c-8244-bc7a49e5796d';
      break;
  }
}

var SCRIPT_ID = 'ze-snippet';
/**
 * Hook for loading Zendesk Web Widget
 */

function useZendesk() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$feZendeskChatbo = _ref2.feZendeskChatbot,
      feZendeskChatbot = _ref2$feZendeskChatbo === void 0 ? false : _ref2$feZendeskChatbo,
      _ref2$loadZendeskScri = _ref2.loadZendeskScript,
      loadZendeskScript = _ref2$loadZendeskScri === void 0 ? true : _ref2$loadZendeskScri;

  useEffect(function () {
    var script = document.getElementById(SCRIPT_ID); // Only load the script client side

    if (typeof window !== 'undefined' && !script && loadZendeskScript) {
      var _script = document.createElement('script');

      _script.id = SCRIPT_ID;
      _script.src = "https://static.zdassets.com/ekr/snippet.js?key=".concat(ZENDESK_CHAT_ID);
      document.head.appendChild(_script);
    }

    return function () {
      if (script) {
        // Cleanup the script
        document.head.removeChild(script);
      }
    };
  }, [loadZendeskScript]); // Handles chat widget logic after load based on the FF feZendeskChatbot

  useZendeskChat({
    feZendeskChatbot: feZendeskChatbot,
    widgetState: widgetState
  });
}
/**
 * Helpers
 */

/**
 * Returns whether the Zendesk widget is available
 */


function zendeskAvailable() {
  return typeof window !== 'undefined' && (window.zE || window.Cypress);
}

function openZendeskWidget(rightPos, zIndexOverride, defaultWidgetOffset) {
  if (zendeskAvailable()) {
    // Open chat window if Zendesk chat is available and place widget for when it's activated.
    zendeskSettings(true, rightPos, zIndexOverride, defaultWidgetOffset); // Keep the widget open now

    widgetState.open = true; // Opens window

    if (window.zE.activate) {
      window.zE.activate();
    }
  }
}

function closeZendeskWidget() {
  if (zendeskAvailable()) {
    //  Close chat window if Zendesk chat is available and update placement
    zendeskSettings(false); // Close Zendesk

    window.zE.hide && window.zE.hide();
  }
}

export default useZendesk;
export { closeZendeskWidget, emitUpdateZendeskHelpPosition, openZendeskWidget, setEnv, zendeskAvailable, zendeskSettings };